import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import CommentList from './commetList'
import {useApolloClient} from '@apollo/client'
import {
  GET_ACTUEL_NEWS,
  GET_HIERARCHY_LIST,
  GET_PRODUCT_HIERARHCY_BY_DEPTH,
  GET_SETTING,
} from '../../store/queries'
import {
  ActivityNode,
  ProductEdge,
  ProductHierarchyEdge,
  ProductHierarchyNode,
  ProductHierarcyEdge,
  ProductHierarcyNode,
  ProductTag,
} from '../../types'
import moment from 'moment'
import {appendPageLink, deletePageLinks} from '../../../setup/redux/PageTitleSlicer'
import {RootState} from '../../../setup/redux/RootReducer'
import HierarchyList from './components/HierarchyList'
import {deleteHaberler, setHaberler} from './redux/haberlerSlicer'
import {SetPageTitleData} from '../../../setup/redux/PageTitleOperation'
import {isMobile} from 'react-device-detect'
import {deleteProductHierarchy, setProductHierarchies} from './redux/productHierarchySlicer'
import {spawn} from 'child_process'
import {setMainLoading} from '../../../setup/redux/loadingSlice'
import TagList from './components/TagList'

export default function SalesPediaMain() {
  const [loading, setLoading] = useState<boolean>(false)
  const [searchText, setSearchText] = useState<string>()
  const activityState = useSelector((state: RootState) => state.haberReducer)
  const productHierarchyState = useSelector((state: RootState) => state.productHierarchyReducer)
  const [specialProductTags, setSpecialProductTag] = useState<ProductTag[] | undefined>(undefined)
  const [specialKitchenTags, setSpecialKitchenTag] = useState<ProductTag[] | undefined>(undefined)
  const [allSalesPediaTags, setAllSalesPediaTag] = useState<ProductTag[] | undefined>(undefined)

  let hasMoreValue = false

  const client = useApolloClient()
  var cursor: string | undefined = undefined
  const dispatch = useDispatch()

  async function getActivity(): Promise<any> {
    let today = moment().add('hours', 3).format('YYYY-MM-DD HH:MM')
    console.log('today =>> ', moment().format('DD-MM-YYYY hh:mm'))
    console.log('today + 3 h =>> ', moment().add(3, 'hour').format('hh:mm'))

    return await client
      .query({
        query: GET_ACTUEL_NEWS,
        variables: {cursor: cursor, todayDate: today},
      })
      .then((resp) => {
        setLoading(false)
        if (resp.errors) {
          return false
        } else {
          // let data = activityList != undefined ? [...activityList!, ...resp.data.activities.edges] : resp.data.activities.edges;
          // console.log("data =>>", data);
          // setActivityList(data);
          console.log('49 resp.data.activities.edges', resp.data.activities.edges)
          dispatch(setHaberler(resp.data.activities))
          const pi = resp.data.activities.pageInfo
          cursor = pi.endCursor
          return pi.hasNextPage
        }
      })
      .catch((err) => {
        console.log('error activity list => ', err)
        return false
      })
  }

  async function startWhile(hasMore: boolean) {
    while (hasMore) {
      setLoading(true)
      hasMore = await getActivity()
    }
    setLoading(false)
  }

  var cursor2: string | undefined = undefined

  async function startHierarchyWhile(hasMore2: boolean) {
    dispatch(setMainLoading(true))
    let buffer: ProductHierarchyEdge = {
      edges: [],
    }
    const getHierarchyList = async () => {
      return await client
        .query({
          query: GET_PRODUCT_HIERARHCY_BY_DEPTH,
          variables: {cursor: cursor2},
        })
        .then((resp) => {
          setLoading(false)
          if (resp.errors) {
            return false
          } else {
            console.log('49 resp.data.productHierarchies.edges', resp.data.productHierarchies)
            let edges = resp.data.productHierarchies.edges.filter(
              (e: ProductHierarchyNode) => e.node.productHierarchyCode != 'SPZZ'
            )
            buffer!.edges?.push(...edges)

            const pi = resp.data.productHierarchies.pageInfo
            cursor2 = pi.endCursor
            return pi.hasNextPage
          }
        })
        .catch((err) => {
          console.log('error productHierarchies list => ', err)
          return false
        })
    }

    while (hasMore2) {
      hasMore2 = await getHierarchyList()
    }
    console.log('while bitti')

    dispatch(setProductHierarchies(buffer))

    dispatch(setMainLoading(false))
  }

  useEffect(() => {
    dispatch(deleteHaberler([]))
    startWhile(true)

    async function getProductTag() {
      return await client
        .query({
          query: GET_SETTING,
          variables: {key: 'SalesPediaTags'},
        })
        .then((resp) => {
          console.log('setting => ', resp)
          if (resp.error) {
            return false
          } else {
            try {
              var specialKitchen: ProductTag[] = JSON.parse(
                resp.data.settings.edges[0].node.value
              ).SalesPediaTags.OzelMutfaklar.map((x: ProductTag) => {
                return x
              })
              var specialProduct: ProductTag[] = JSON.parse(
                resp.data.settings.edges[0].node.value
              ).SalesPediaTags.OzelUrunler.map((x: ProductTag) => {
                return x
              })
              var allSalesPediaTags: ProductTag[] = JSON.parse(
                resp.data.settings.edges[0].node.value
              ).SalesPediaTags.AllSalesPediaTags.map((x: ProductTag) => {
                return x
              })
              setAllSalesPediaTag(allSalesPediaTags)
              setSpecialProductTag(specialProduct)
              setSpecialKitchenTag(specialKitchen)
            } catch (err) {
              console.log('burada => ', err)
            }
          }
        })
        .catch((err: any) => {
          console.log('error setting => ', err)
          return false
        })
    }
    dispatch(deletePageLinks([]))
    startHierarchyWhile(true)
    getProductTag()
  }, [])

  const getStatementValue = (activityNode: ActivityNode, statementCode: string) => {
    var statement = activityNode.node.activityStatements.find(
      (x) => x.statementCode == statementCode
    )
    if (statementCode != 'A8') {
      return statement?.value
    } else {
      return statement?.notes
    }
  }

  const filterProduct = (activityNode: ActivityNode) => {
    if (searchText != undefined && searchText.length > 2 && activityNode != undefined) {
      if (
        getStatementValue(activityNode, 'A1')?.toLowerCase().includes(searchText.toLowerCase()) ||
        getStatementValue(activityNode, 'A8')?.toLowerCase().includes(searchText)
      ) {
        return true
      } else {
        return false
      }
    }
    return true
  }

  useEffect(() => {
    console.log('Değişimmm => ', productHierarchyState)
  }, [productHierarchyState])
  console.log(
    '-',
    productHierarchyState,
    '---',
    specialProductTags,
    '---------',
    specialKitchenTags
  )
  return (
    <div className='d-flex flex-column flex-column-fluid'>
      <div className='col-xxl-12 gy-0 gy-xxl-8'>
        <div className='card card-stretch mb-5 mb-xxl-8'>
          <div className='card-body'>
            <div className='row'>
              <div className='col-sm-12 col-xs-12 col-md-8'>
                <HierarchyList
                  productHierarchyEdge={productHierarchyState as ProductHierarcyEdge | undefined}
                  title='Ürünler'
                  dispatch={dispatch}
                />

                <TagList
                  productTags={specialProductTags}
                  dispatch={dispatch}
                  title='Özel Ürünler'
                ></TagList>
                <TagList
                  dispatch={dispatch}
                  productTags={specialKitchenTags}
                  title='Özel Mutfaklar'
                ></TagList>
              </div>

              <div className='col-sm-12 col-md-4'>
                <div className='container'>
                  <div className='col'>
                    <div className='text-center'>
                      <h4 className='fs-2hx text-dark mb-5'>
                        <span>Haberler</span>
                      </h4>
                    </div>

                    {activityState.activityList && activityState.activityList.length > 0 ? (
                      <>
                        <div className='card-body' style={{width: '100%'}}>
                          <div className='input-group input-group-lg'>
                            <input
                              type='text'
                              value={searchText}
                              onChange={(event: any) => setSearchText(event.target.value)}
                              className='form-control'
                              aria-label=''
                              aria-describedby='inputGroup-sizing-lg'
                              placeholder='Haber Ara'
                            />
                          </div>
                        </div>
                        <div
                          className='col-sm'
                          style={{overflowY: 'scroll', overflowX: 'hidden', height: '800px'}}
                        >
                          {activityState.activityList
                            ?.filter((x) => filterProduct(x))
                            .map((x) => (
                              <CommentList
                                title={getStatementValue(x, 'A1')}
                                paragraph={getStatementValue(x, 'A8')}
                                key={x.node.activityId}
                              />
                            ))}
                        </div>
                      </>
                    ) : (
                      <div style={{textAlign: 'center'}}>
                        <span>Haber paylaşımı bulunmuyor.</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
